import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { Modal, ModalActions } from '../../../components/Modal'
import { InboxType } from '../../../../server/models/Inbox'
import { deleteInbox } from '../../../requests/inboxes'
import { handleError } from '../../../errors/handleError'

type Props = {
  onClose: () => void
  inboxToDelete: InboxType
  onInboxDeleted: (inboxDeleted: InboxType) => void
}

export const DeleteInboxModal: React.FC<Props> = ({ onClose, inboxToDelete, onInboxDeleted }) => {
  const [deleting, setDeleting] = useState(false)

  const closeModal = () => {
    onClose()
  }

  const onDeleteInbox = async () => {
    setDeleting(true)
    try {
      await deleteInbox(inboxToDelete._id)
      onInboxDeleted(inboxToDelete)
      setDeleting(false)
      closeModal()
      toast.success('Folder deleted.')
    } catch (err) {
      handleError(err, 'Something went wrong removing this folder. Please try again.')
      setDeleting(false)
      onClose()
    }
  }

  return (
    <Modal isOpen={!!inboxToDelete} onRequestClose={closeModal}>
      <h2>Are you sure you want to delete {`"${inboxToDelete?.name}"`}?</h2>
      <p>
          This action cannot be undone.
      </p>
      <ModalActions
        onCancel={closeModal}
        onSubmit={onDeleteInbox}
        loading={deleting}
        submitText="Delete"
      />
    </Modal>
  )
}
